export enum SectionType {
  Theme = 'SECTIONS_TYPES_THEME',
  Personalized = 'SECTIONS_TYPES_PERSONALIZED',
  Preset = 'SECTIONS_TYPES_PRESET',
  PresetList = 'SECTIONS_TYPES_PRESET_LIST',
  Data = 'SECTIONS_TYPES_DATA',
  GenericListSection = 'SECTIONS_TYPES_GENERIC_LIST_SECTION',
  Stylable = 'SECTIONS_TYPES_STYLABLE',
  Welcome = 'SECTIONS_TYPES_WELCOME',
  ResponsivePresetManager = 'RESPONSIVE_PRESET_MANAGER',
  DynamicMediaSectionsBox = 'DYNAMIC_MEDIA_SECTIONS_BOX',
  SiteMediaSection = 'SITE_MEDIA_SECTION',
  DesignDataPreset = 'SECTIONS_TYPES_DESIGN_DATA_PRESET',
  DesignDataThemePreset = 'SECTIONS_TYPES_DESIGN_DATA_THEME_PRESET',
  PersonalizedDesign = 'SECTIONS_TYPES_PERSONALIZED_DESIGN',
  CategorySearchSection = 'CATEGORY_SEARCH_SECTION',
  MyWidgets = 'SECTIONS_TYPES_MY_WIDGETS',
  Custom = 'SECTIONS_TYPES_CUSTOM',
  Action = 'ACTION_SECTION',
  RelatedApps = 'RELATED_APPS_SECTION',
  Logo = 'LOGO_SECTION',
}

export enum WelcomeSectionListType {
  Numeric = 'numeric',
  Promotional = 'promotional',
}
